
    import { Component, Prop } from 'nuxt-property-decorator';
    import { namespace } from 'nuxt-property-decorator';
    import { IPage } from '@/store/page';
    import HandleResultMixin, { HandleType } from '@/mixins/handleResultMixin';

    const pages = namespace('pages');

    @Component
    export default class OptionsFieldsPages extends HandleResultMixin {
        @Prop() entity;
        @pages.Action fetchAllPages;
        @pages.State pages;
        @pages.Action saveOnePage;

        filteredPages: IPage[] = [];

        async beforeMount() {
            await this.fetchAllPages();
            if (this.pages) {
                this.filteredPages = this.pages.filter(page => {
                    return page.components.find(component => {
                        return component.preset === this.entity.id;
                    });
                });
            }
        }

        selectAll() {
            this.filteredPages = this.filteredPages.map(page => ({
                ...page,
                update: !page.update
            }));
        }

        async updatePages() {
            const pagesForUpdate = this.filteredPages.filter(page => page['update']);
            const promises = [] as any;
            pagesForUpdate.forEach(page => {
                const newPage = { ...page };
                let pageUpdate = false;
                newPage.components.forEach(component => {
                    if (
                        component['preset'] === this.entity.id &&
                        component.name === this.entity.options.component
                    ) {
                        component.options = this.entity.options.preset;
                        pageUpdate = true;
                    }
                });

                if (pageUpdate) {
                    promises.push(
                        this.saveOnePage({
                            page: newPage,
                            saveComponents: true
                        })
                    );
                }
            });

            if (promises.length) {
                const results = await Promise.all(promises);
                results.forEach(result => {
                    this.handleResult(result, HandleType.Toast);
                });
            }
        }
    }
